import * as React from 'react';

import tinytime from 'tinytime';

import { Text } from '@components/common';
import { SignedConsentForms } from '@components/SignedConsentForms';
import { useFeature } from '@hooks/useFeature';
import { api } from 'api/reduxApi';

const template = tinytime('{MMMM} {DD} at {h}:{mm}{a}');

export const ConsentForms: React.FC<React.PropsWithChildren<{ participation: Participation }>> = ({
  participation
}) => {
  const { data: consent_forms, isSuccess } = api.useGetParticipationConsentFormQuery(
    { id: participation.id },
    {
      skip: !participation.consented
    }
  );

  if (!participation.consented) {
    return (
      <Text mb='2' color='gray-500'>
        This participant has not yet provided consent.
      </Text>
    );
  }

  return (
    <div className='flex flex-col gap-y-4'>
      {participation.consented && <div>This participant has agreed to the standard data and opt out clauses</div>}

      {(consent_forms || []).length > 0 && (
        <Text bold mt='2'>
          Signed consent form
        </Text>
      )}

      <SignedConsentForms consentForms={consent_forms || []} variant='slideout' />
    </div>
  );
};
